import { Button, LoadingPane, Pane, PaneFooter } from '@folio/stripes/components';
import { useStripes } from '@folio/stripes/core';
import React, { useCallback, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { formValuesToDto, schedulingToDto } from './api/dto/to';
import { useAutomaticSchedulerMutation, useManualSchedulerMutation } from './api/mutators';
import ConfigurationForm from './components/ConfigurationForm';
import { FORM_ID } from './constants';
import useInitialValues from './hooks/useInitialValues';
export default function BursarExportPlugin() {
    var stripes = useStripes();
    var initialValues = useInitialValues();
    var scheduleManually = useManualSchedulerMutation();
    var scheduleAutomatically = useAutomaticSchedulerMutation();
    var formApiRef = useRef(null);
    var submitCallback = useCallback(function (values) {
        scheduleAutomatically({
            bursar: formValuesToDto(values),
            scheduling: schedulingToDto(values.scheduling),
        });
    }, [scheduleAutomatically]);
    var runManuallyCallback = useCallback(function () {
        var _a;
        var values = (_a = formApiRef.current) === null || _a === void 0 ? void 0 : _a.getState().values;
        if (values) {
            scheduleManually(formValuesToDto(values));
        }
    }, [formApiRef, scheduleManually]);
    var footer = (React.createElement(PaneFooter, { renderStart: React.createElement(Button, { disabled: initialValues == null || !stripes.hasPerm('data-export.job.item.post'), form: FORM_ID, onClick: runManuallyCallback },
            React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.button.runManually" })), renderEnd: React.createElement(Button, { disabled: initialValues == null || !stripes.hasPerm('data-export.config.item.post'), buttonStyle: "primary", type: "submit", form: FORM_ID },
            React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.button.save" })) }));
    if (initialValues === null) {
        return (React.createElement(LoadingPane, { paneTitle: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.paneTitle" }), defaultWidth: "fill", footer: footer }));
    }
    return (React.createElement(Pane, { defaultWidth: "fill", footer: footer, id: "pane-batch-group-configuration", paneTitle: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.paneTitle" }) },
        React.createElement(ConfigurationForm, { initialValues: initialValues, onSubmit: submitCallback, formApiRef: formApiRef })));
}
